import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {login, fetchUser, logout} from '../redux/actions'
import {parseErrorMessages} from '../utils/auth'
import {
  ModalBody, ModalHeader, ModalFooter,
  Form, FormGroup, FormFeedback, Input,
  Spinner
} from 'reactstrap'
import { Link, navigate } from 'gatsby'
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'
import { Trans, withTranslation } from 'react-i18next'
import {toast} from 'react-toastify'
import { getI18nURLPrefix } from '../utils/localStorage'


class ModalAuthLogin extends React.Component {
  static propTypes = {
    token: PropTypes.string, 
    error: PropTypes.array,
    login: PropTypes.func,
    logout: PropTypes.func,
    fetchUser: PropTypes.func,
  }

  constructor(props){
    super(props)
    this.state = {
      email: '',
      password: '',
      messages: [],
      isLoading: false,
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  componentDidUpdate(prevProps){
    if (prevProps.error !== this.props.error) {
      const messages = parseErrorMessages(this.props.error)
      this.setState({messages: messages})
    }
  }

  handleInputChange(event){
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		this.setState({[name]: value})
  }

  async handleFormSubmit(event) {
    event.preventDefault()
    const {t} = this.props
    const {email, password} = this.state
    this.setState({isLoading: true})
    const prefix = await getI18nURLPrefix()

    await this.props.login({email,password})
    if (this.props.token) {
      await this.props.fetchUser(this.props.token)
      this.props.toggle()

      trackCustomEvent({
        category: "Login Form",
        action: "Login success",
        label: `Login success ${email}`,
      })
      // Temporary fix until we connect to redux and are able to update state when prop changes)
      localStorage.removeItem('homepageSavedSlug')
      localStorage.removeItem('homepageState')
      localStorage.removeItem('homepageSavedDate')
      const username = await localStorage.getItem('userName')
      navigate(`${prefix}`)
      toast.success(`${t('Bonjour')} ${username}`)
      setTimeout(() => window.location.reload() , 2000) 
    } else {
      trackCustomEvent({
        category: "Login Form",
        action: "Login failure",
        label: `Login failure ${email}`,
      })
      toast.error(t('Une erreur est survenue'))
    }
    this.setState({isLoading: false})
  }

  
  render() {
    const {isLoading} = this.state
    const {t} = this.props
    return(
      <div>
        <ModalHeader toggle={this.props.toggle}><Trans>Se connecter</Trans></ModalHeader>
        <Form onSubmit={this.handleFormSubmit}>
          <ModalBody className="pb-0">
              {this.state.messages}
              <FormGroup>
                <Input name="email" type="email" placeholder={t("Email")} value={this.state.email} onChange={this.handleInputChange}/>
                <FormFeedback valid>Sweet! that name is available</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Input name="password" type="password" placeholder={t("Mot de passe")} value={this.state.password} onChange={this.handleInputChange}/>
                <FormFeedback valid>Sweet! that name is available</FormFeedback>
                <Link to="/user/password_reset/" className="text-muted btn btn-link btn-sm m-0 p-0"><Trans>Mot de passe oublié ?</Trans></Link>
              </FormGroup>
              <button type="submit" className="d-none"></button>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" onClick={this.handleFormSubmit} className="btn btn-primary btn-lg mb-0">
              {isLoading && <Spinner size="sm"/> || <Trans>Se connecter</Trans>}
            </Button>
          </ModalFooter>
        </Form>
        <BottomSection>
          {/* <span> <a href="#" className="text-light">Mot de passe oublié ? </a></span>
          <span> · </span> */}
          <span onClick={this.props.switchAuth} className="btn btn-link btn-sm text-light mr-1 p-0"><Trans>Créer un compte</Trans></span>
          <span> · </span>
          <span className="btn btn-link btn-sm text-light p-0 ml-1" onClick={this.props.toggle}><Trans>Fermer</Trans></span>
        </BottomSection> 
      </div>
    )
  }
}

const mapStateToProps = state => ({
  token: state.user.token,
  error: state.user.loginError,
})

export default connect(mapStateToProps, {login, fetchUser, logout})(withTranslation()(ModalAuthLogin))



const Button = styled.button`
  color: #fff;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.4s;
  line-height: normal;
  border: none;
  font-size: 16px;
  font-weight: bold;
  background: #99c432;		
  margin-bottom: 20px;
  float: left;
  margin: 1px 0 20px 0;
  width: 100%;
  min-width: 20px;
  font-size: 18px;
  background-color: #2557b7;
  &:hover{
    background: #346bc2;
  }
`

const BottomSection = styled.div`
  position: absolute;
  color: #efefef;
  width: 100%;
  font-size: 13px;
  padding: 1rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`